import React from 'react';
import { createStyles } from './styles';

interface Props {
  invalidProductLineIdsWithMessage: Record<string, string>[];
}

const CarrierRulesViolation: React.FC<Props> = ({ invalidProductLineIdsWithMessage }) => {
  const classes = createStyles();
  return invalidProductLineIdsWithMessage.length > 0 ? (
    <div className={classes.validationBlock}>
      <b className={classes.validationBlockTitle}>Attention! You cannot proceed with the current cart</b>
      <ul className={classes.validations}>
        {invalidProductLineIdsWithMessage.map((line) => {
          return Object.entries(line).map(([pLineId, message]) => <li key={`invalid-${pLineId}`}>{message}</li>);
        })}
      </ul>
    </div>
  ) : null;
};

export default CarrierRulesViolation;
